var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.expert ? _c('view-card', {
    attrs: {
      "title": "기업 소개"
    }
  }, [_c('data-list', {
    attrs: {
      "dataList": _vm.dataList
    }
  }, [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "tag": "li",
      "cols": "12"
    }
  }, [_c('dt', [_vm._v("사업분야")]), _c('dd', [_c('item-area-badges', {
    attrs: {
      "areas": _vm.expert.areas
    }
  })], 1)]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "tag": "li",
      "cols": "12"
    }
  }, [_c('dt', [_vm._v("기업소개")]), _c('dd', [_vm._v(_vm._s(_vm.expert.summary))])]), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "tag": "li",
      "cols": "12"
    }
  }, [_c('dt', [_vm._v("소개자료")]), _c('dd', [_c('view-brochures', {
    attrs: {
      "brochures": _vm.expert.brochures
    }
  })], 1)])], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }